import React, { useState } from "react";
import { useSelector } from "react-redux";
import { FiMoreVertical, FiPlus } from "react-icons/fi";
import { SiVisa } from "react-icons/si";

import CardDetail from "../../StyledComponents/CardDetails";
import AddCard from "../../StyledComponents/AddCard";

import { PageSubTitle, Image } from "../../StyledComponents";
import {
  Div,
  // Card,
  // Icon,
  // CardGroup,
  // CardContainer,
  // CardNum,
  // CardHoldTxt,
  // HoldName,
  // CardBrand,
  // Curcle,
  // InnerCurcle,
  Tooltip,
  TooltipText,
  // New Styles
  NewCardGroup,
  NewCardContainer,
  NewCardHeader,
  NewChipIcon,
  NewCardDots,
  NewCardNumber,
  NewCardFooter,
  NewCardInfo,
  NewInfoItem,
  NewInfoLabel,
  NewInfoValue,
  NewVisaLogo,
  NewAddCardBox,
  NewAddIconCircle,
  NewAddText,
  NewPlaceholderBars,
  NewBar,
} from "./Styles";

import ChipPin from "../../../Assets/images/Group.png";
import StripeAlert from "../../StyledComponents/StripeAlert";

const MyCards = () => {
  const [AddShow, setAddShow] = useState(false);
  const [CardDetailShow, setCardDetailShow] = useState(false);
  const [CardData, setCardData] = useState({});

  const CardDetails = useSelector((state) => state.Billing.CardDetail);
  const [NumCard] = useState(CardDetails.length);
  const stripeAllowed = useSelector((state) => state.Billing.stripeAllowed);
  const [ModalAlerShow, setModalAlerShow] = useState(false);

  const HandleModal = () => {
    if (stripeAllowed === false) {
      setModalAlerShow(true);
    } else {
      setAddShow((prevState) => !prevState);
    }
  };
  const HandleEdit = (ind) => {
    setCardDetailShow((prevState) => !prevState);
    setCardData(ind);
  };

  const handleModalClick = () => {
    setModalAlerShow(false);
  };
  return (
    <>
      <Div>
        <PageSubTitle>My Card</PageSubTitle>

        <NewCardGroup>
          {CardDetails.length !== 0 ? (
            <>
              {CardDetails.map((row, ind) => (
                <NewCardContainer key={ind} onClick={() => HandleEdit(row)}>
                  <NewCardHeader>
                    <NewChipIcon />
                    <NewCardDots>
                      <FiMoreVertical />
                    </NewCardDots>
                  </NewCardHeader>

                  <NewCardNumber>
                    {row.number || "xxxx xxxx xxxx xx89"}
                  </NewCardNumber>

                  <NewCardFooter>
                    <NewCardInfo>
                      <NewInfoItem>
                        <NewInfoLabel>Card Holder</NewInfoLabel>
                        <NewInfoValue>
                          {row.name && row.name.length > 12 ? (
                            <Tooltip>
                              {row.name}
                              <TooltipText className="TooltipText">
                                {row.name}
                              </TooltipText>
                            </Tooltip>
                          ) : (
                            row.name || "Black Marvin"
                          )}
                        </NewInfoValue>
                      </NewInfoItem>
                      <NewInfoItem>
                        <NewInfoLabel>Valid</NewInfoLabel>
                        <NewInfoValue>{row.valid || "09/25"}</NewInfoValue>
                      </NewInfoItem>
                    </NewCardInfo>
                    <NewVisaLogo>
                      <SiVisa size={40} />
                    </NewVisaLogo>
                  </NewCardFooter>
                </NewCardContainer>
              ))}
              {CardDetails.length < 3 && (
                <NewAddCardBox onClick={() => HandleModal()}>
                  <NewAddIconCircle>
                    <FiPlus size={24} />
                  </NewAddIconCircle>
                  <NewAddText>Add Card</NewAddText>
                  <NewPlaceholderBars>
                    <NewBar width="40px" />
                    <NewBar width="60px" />
                    <NewBar width="80px" />
                    <NewBar width="30px" />
                  </NewPlaceholderBars>
                </NewAddCardBox>
              )}
            </>
          ) : (
            <NewAddCardBox onClick={() => HandleModal()}>
              <NewAddIconCircle>
                <FiPlus size={24} />
              </NewAddIconCircle>
              <NewAddText>Add Card</NewAddText>
              <NewPlaceholderBars>
                <NewBar width="40px" />
                <NewBar width="60px" />
                <NewBar width="80px" />
                <NewBar width="30px" />
              </NewPlaceholderBars>
            </NewAddCardBox>
          )}
        </NewCardGroup>

        {/* Existing Code Commented Out
        <CardGroup>
          {CardDetails.length !== 0 ? (
            <>
              {CardDetails.map((row, ind) => (
                <>
                  <CardContainer
                    key={ind}
                    selected={ind}
                    onClick={() => HandleEdit(row)}
                  >
                    <Div
                      margin="0px 0px 27px 0px"
                      display="flex"
                      alignItems="center"
                    >
                      <Image loading="lazy" src={ChipPin} />
                    </Div>

                    <CardNum selected={ind}>{row.number}</CardNum>

                    <Div
                      display="flex"
                      margin="20px 0px 0px 0px"
                      alignItems="center"
                      justify="space-between"
                    >
                      <Div justify="space-between" width="100px">
                        <CardHoldTxt selected={ind}>Card Holder</CardHoldTxt>
                        <HoldName
                          selected={ind}
                          textOverflow="ellipsis"
                          whiteSpace="nowrap"
                          overflow="hidden"
                        >
                          {row.name && row.name.length > 12 ? (
                            <Tooltip>
                              {row.name}
                              <TooltipText className="TooltipText">
                                {row.name}
                              </TooltipText>
                            </Tooltip>
                          ) : (
                            row.name
                          )}
                        </HoldName>
                      </Div>

                      <Div margin="0px 0px 0px 16px">
                        <CardHoldTxt selected={ind}>Valid</CardHoldTxt>
                        <HoldName selected={ind}>{row.valid}</HoldName>
                      </Div>

                      <CardBrand img={row.cardType} selected={ind} />
                    </Div>

                    <Curcle selected={ind} />
                    <InnerCurcle selected={ind} />
                  </CardContainer>
                </>
              ))}
              {CardDetails.length < 3 && (
                <Card onClick={() => HandleModal()}>
                  <Icon />
                  Add Card
                </Card>
              )}
            </>
          ) : (
            <Card onClick={() => HandleModal()}>
              <Icon />
              Add Card
            </Card>
          )}
        </CardGroup>
        */}
      </Div>

      <AddCard
        show={AddShow}
        HandleModal={() => setAddShow(false)}
        numcard={NumCard}
      />

      <CardDetail
        show={CardDetailShow}
        HandleClose={() => setCardDetailShow(false)}
        row={CardData}
      />
      {ModalAlerShow && (
        <StripeAlert show={ModalAlerShow} handleModalClick={handleModalClick} />
      )}
    </>
  );
};

export default MyCards;
